module.exports = __webpack_public_path__ + "img/code2.99fa2056.jpg";